import comp from "./AssessmentTool";
export default comp;
